export interface IPendingOrder {
    pendingOrderId: string;
    address?: string;
    contentProviderId?: number;
    orderCollectionId?: number;
}

const STORE_ITEM_NAME: string = 'pendingOrderStore';

class PendingOrderStore {
    public constructor() {}

    public get(): IPendingOrder {
        try {
            let itemsJson = window.sessionStorage.getItem(STORE_ITEM_NAME);
            let result = JSON.parse(itemsJson);
            return result;
        } catch {
            return null;
        }
    }

    public save(order: IPendingOrder): void {
        window.sessionStorage.setItem(STORE_ITEM_NAME, JSON.stringify(order));
    }

    public clear(): void {
        window.sessionStorage.removeItem(STORE_ITEM_NAME);
    }
}

export default new PendingOrderStore();
